"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockOracleFactory = /** @class */ (function (_super) {
    __extends(MockOracleFactory, _super);
    function MockOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockOracleFactory;
}(contracts_1.ContractFactory));
exports.MockOracleFactory = MockOracleFactory;
var _abi = [
    {
        inputs: [],
        name: "CURRENT_PRICE",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "price",
                type: "tuple",
            },
        ],
        name: "setPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60a0604052678ac7230489e80000608081905260005534801561002157600080fd5b5061011b806100316000396000f3fe6080604052348015600f57600080fd5b5060043610603c5760003560e01c80630c15e4071460415780634b369a6114605457806396a0e5e3146070575b600080fd5b6052604c366004609a565b51600055565b005b600054605d9081565b6040519081526020015b60405180910390f35b60408051602080820183526000918290528251908101909252548152604051905181526020016067565b60006020828403121560aa578081fd5b6040516020810181811067ffffffffffffffff8211171560d857634e487b7160e01b83526041600452602483fd5b604052913582525091905056fea2646970667358221220f508c39786a57795f8e9d9454ba69ffcd7e38775480bb122bb6a8f88d84993e764736f6c63430008040033";
